import { create } from "zustand";
import type { IChip, ICompany, ICusTemplate, ITemplate } from "./interface/scan";
import http from "@/api/http";
import { createJSONStorage, persist } from "zustand/middleware";
import { GetLocalStorage } from "@/utils/helper";

interface State {
  serial: string | null;
  chip: IChip | null;
  company: ICompany | null;
  template: ITemplate | null;
  cusTemplate: ICusTemplate | null;
  googleAnalyticsId: string | null;
}

interface Actions {
  scanChip: (serial: string) => Promise<void>;
  verifyChip: () => Promise<void>;
  setCusTemplate: (cusTemplate: ICusTemplate) => void;
}

const initState: State = {
  serial: null,
  chip: null,
  company: null,
  template: null,
  cusTemplate: null,
  googleAnalyticsId: null,
};

const scanStore = create(
  persist<State & Actions>(
    (set, get) => ({
      ...initState,
      scanChip: async (serial) => {
        try {
          const res = await http.get(`/scan/${serial}`);
          if (res.status === 200) {
            set({
              serial: serial,
              chip: res.data,
              company: res.data.company,
              template: res.data.template,
              cusTemplate: res.data.cus_template ?? null,
            });

            try {
              const settingsRes = await http.get(`/common-settings/${serial}`);
              const analyticsSetting = (settingsRes?.data as any[])?.find(
                (s: any) => s.type === "analytics"
              );
              const gaId = analyticsSetting?.credentials?.google_analytics;
              if (gaId) {
                set({ googleAnalyticsId: gaId });
              }
            } catch {
              // analytics settings are optional, ignore errors
            }
          }
        } catch (error) {
          console.log("error", error);
        }
      },
      setCusTemplate: (cusTemplate) => {
        set({ cusTemplate });
      },
      verifyChip: async () => {
        const serial = get().serial || GetLocalStorage("scan-storage", "serial");
        const res = await http.post(`/verify/${serial}`);
        if (res.status === 200) {
          set({ chip: { ...get().chip!, status: "activated" } });
        } else {
          throw new Error("Verify failed");
        }
      },
    }),
    {
      name: "scan-storage",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export default scanStore;
